import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace CapaTypesFields {
  export enum CommonField {
    CapaTypesSequentialNumberingFormat = 'CapaTypes.SequentialNumberingFormat',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(CapaTypesFields.CommonField.CapaTypesSequentialNumberingFormat, '')
  sequentialNumberingFormat: SettingValue<string>;
}

export class CapaTypesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
